export const continueWithoutSaving = `Are you sure you wish to continue without saving?`;
export const selectSave = `Select ‘save inputs’ if you wish to save your progress so far.`;
export const saveInputs = `Save Inputs`;
export const continueWithout = `Continue without saving`; 